import axios from 'axios'

const MAX_ATTEMPTS = 3
const RETRY_DELAY_MS = 1000

function isRetryable(error: unknown) {
  if (!axios.isAxiosError(error)) return false
  const status = error.response?.status
  if (status === undefined) return true
  return status >= 500 || status === 408 || status === 429
}

function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export default async function uploadToS3(url: string, file: File) {
  for (let attempt = 1; ; attempt++) {
    try {
      return await axios.put(url, file, {
        headers: {
          // S3 rejects the upload with a 403 unless Content-Type is empty.
          'Content-Type': '',
        },
      })
    } catch (error) {
      // The signed url only allows a PUT when no file exists yet.
      // A 412 means an earlier attempt already uploaded the file.
      if (axios.isAxiosError(error) && error.response?.status === 412) {
        return error.response
      }
      if (attempt >= MAX_ATTEMPTS || !isRetryable(error)) throw error
      await wait(RETRY_DELAY_MS * attempt)
    }
  }
}
